import styled from 'styled-components';
import { Button } from 'antd';

export const ButtonWrapper = styled(Button)``;
